export const setupSubMenu = (): void => {
  const subMenuCloseButtons = document.querySelectorAll<HTMLElement>("[data-submenu-close]")
  subMenuCloseButtons.forEach((closeButton) => {
    closeButton?.addEventListener("click", onClick)
  })
}

const onClick = (): void => {
  document.querySelectorAll<HTMLElement>("[data-accordion]").forEach((item) => {
    closeMenu(item)
  })
}

const closeMenu = (element: HTMLElement): void => {
  element.removeAttribute("open")
  element.setAttribute("aria-expanded", "false")
  element.classList.remove("accordion-active")
  element.querySelectorAll<HTMLElement>("[data-accordion-interactive]").forEach((subElement) => {
    subElement.tabIndex = -1
  })
}